import { isSSR } from '../../../../utils/helpers';
import { logs } from '../../../../utils/logs';
import type { FormInput } from './ContentSettings.types';

export const getContentSettingsFromSessionStorage = (): FormInput => {
  const defaultSettings = {
    microcopyKeys: false,
    macrocopyKeys: false,
  };

  try {
    if (isSSR() || typeof sessionStorage === 'undefined') {
      return defaultSettings;
    }
  } catch (e) {
    return defaultSettings;
  }

  try {
    const value = sessionStorage.getItem('inspireContentSettings');

    if (!value) {
      return defaultSettings;
    }

    return JSON.parse(value);
  } catch (error) {
    return defaultSettings;
  }
};

export const setContentSettingsToSessionStorage = (settings: FormInput) => {
  try {
    if (isSSR() || typeof sessionStorage === 'undefined') {
      return;
    }
  } catch (e) {
    return;
  }

  try {
    sessionStorage.setItem('inspireContentSettings', JSON.stringify(settings));
  } catch (error) {
    logs.error({
      message: 'Error setting content settings to sessionStorage',
      error,
    });
  }
};
